export default "__VITE_ASSET__5da49b0d__"